import lodashGet from 'lodash.get';
import lodashSet from 'lodash.set';
function crawler(_ref) {
  var data = _ref.data,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? '' : _ref$prefix,
    handler = _ref.handler;
  if (typeof data === 'string') {
    handler(prefix, data);
  } else {
    for (var key in data) {
      var _value = data[key];
      crawler({
        data: _value,
        prefix: prefix ? "".concat(prefix, ".").concat(key) : key,
        handler: handler
      });
    }
  }
}
export var getTranslationResolver = function getTranslationResolver(data, nameSpace) {
  return function (additionalTranslations) {
    var languages = Object.keys(additionalTranslations);
    var result = {};
    var _loop = function _loop() {
      var lang = _languages[_i];
      crawler({
        data: data,
        handler: function handler(path, value) {
          var text = lodashGet(additionalTranslations, "".concat(lang, ".").concat(nameSpace, ".").concat(value));
          if (text !== undefined) {
            lodashSet(result, "".concat(lang, ".").concat(path), text);
          }
        }
      });
    };
    for (var _i = 0, _languages = languages; _i < _languages.length; _i++) {
      _loop();
    }
    return result;
  };
};